export default __webpack_public_path__ + "static/media/hörtest-avatar-03.73a49a75.svg";